import React from 'react'

const DoTheRightThing = () => {
	return (
		<div className='converseValues-content'>
			<h1 className='section-title'>DO THE RIGHT THING*</h1>

			<div className='ncss-row' style={{ marginTop: '48px', borderBottom: '1px solid white', paddingBottom: '50px' }}>
				<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm'>
					<p className='section-title' style={{ fontSize: '40px' }}>
						INTEGRITY
					</p>
					<p className='section-p'>
						We strive to be the best version of ourselves – even when it’s hard. Practicing truth, acting with authenticity
						and embracing positivity. Real people do real things.
					</p>
				</div>
				<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm'>
					<p className='section-title' style={{ fontSize: '40px' }}>
						EMPATHY
					</p>
					<p className='section-p'>
						We are compassionate and seek to understand each other, our community and our future. We imagine how we will make
						things better while we make better things.
					</p>
				</div>
				<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm'>
					<p className='section-title' style={{ fontSize: '40px' }}>
						ACCOUNTABILITY
					</p>
					<p className='section-p'>
						We don’t shy away from responsibility. We consider the best way forward. Fearlessly making the hard choices.
						Owning the impact of our decisions in everything we do.
					</p>
				</div>
			</div>
			<div className='converse-behaviros'>
				<p className='section-title' style={{ marginTop: '50px', marginBottom: '24px', fontSize: '40px' }}>
					Behaviors
				</p>

				<div className='ncss-row' style={{ marginTop: '24px' }}>
					<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm' style={{ verticalAlign: 'top' }}>
						<p className='section-p' style={{ fontSize: '24px' }}>
							I FEARLESSLY SHARE MY THOUGHTS
						</p>
					</div>
					<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm' style={{ verticalAlign: 'top' }}>
						<p className='section-p' style={{ fontSize: '24px' }}>
							PLAY FAIR
						</p>
					</div>
					<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm' style={{ verticalAlign: 'top' }}>
						<p className='section-p' style={{ fontSize: '24px' }}>
							I ACT LIKE AN OWNER BY MAKING THE BEST DESCISIONS
						</p>
					</div>
				</div>
			</div>
		</div>
	)
}

export default DoTheRightThing



// WEBPACK FOOTER //
// ./src/containers/AboutPage/ConverseValues/DoTheRightThing.js